import ImageOptimize from '@/components/ImageOptimize'
import { PageTypeSuffix } from '@/constants'
import { type Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { Autoplay, FreeMode, Grid } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

interface PostListType {
  post: Post[]
}

export const PostList = ({ post }: PostListType) => {
  return (
    <div className={`py-3 bg-white rounded-[12px]`}>
      <div className='flex px-2 items-center relative mb-4'>
        <h6 className='font-bold text-[18px] text-[#000]'>
          Tin tức & khuyến mãi
        </h6>
        <Link
          href='/post'
          className='absolute right-2 top-1/2 -translate-y-1/2 block text-sm text-redPico'
        >
          Xem tất cả
        </Link>
      </div>
      <div className='w-full'>
        <div className='w-full overflow-x-hidden'>
          <Swiper
            modules={[Grid, FreeMode, Autoplay]}
            className='flashSaleSwp'
            slidesPerView={1.8}
            grid={{
              rows: 1,
              fill: 'row',
            }}
            slidesPerGroup={2}
            freeMode={true}
            spaceBetween={8}
          >
            {post &&
              post.length > 0 &&
              post?.map((e, i) => {
                return (
                  <SwiperSlide key={`post-${i}`}>
                    <div className='flex w-full h-[142px]'>
                      <Link
                        href={`/${getTranslate(e?.slugs.value)}${
                          e?.slugs.postfix
                        }${PageTypeSuffix.POST}`}
                      >
                        <ImageOptimize
                          src={e?.images[0]}
                          className='object-cover w-full h-full col-span-2 rounded-[4px]'
                          width={225}
                          height={142}
                          loading='lazy'
                          alt={getTranslate(e?.title)}
                        />
                      </Link>
                    </div>

                    <Link
                      href={`/${getTranslate(e?.slugs.value)}${
                        e?.slugs.postfix
                      }${PageTypeSuffix.POST}`}
                      className={`py-2 flex text-sm font-normal text-[#000]`}
                    >
                      {getTranslate(e?.title)}
                    </Link>
                  </SwiperSlide>
                )
              })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default PostList
